export default {"src":"/_next/static/media/stroke.cf1a6035.svg","height":31,"width":32,"blurWidth":0,"blurHeight":0};